import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import getOffsetTop from '../../utils/getOffsetTop';

import css from './pageSplitter.scss';

export default class TimelinePageSplitter extends Component {
	static propTypes = {
		page: PropTypes.number,
		browser: PropTypes.object.isRequired,
		updatePushState: PropTypes.func,
		lastSplitter: PropTypes.func,
	};

	static defaultProps = {
		page: 1,
		updatePushState: () => {},
	};

	constructor(props) {
		super();
		this.lastValue = false;

		this.state = {
			isActivePage: false,
		};
	}

	componentWillMount() {}

	componentDidMount() {
		const elementTrigger = getOffsetTop(this.refs.splitter);
		// let debug = document.createElement('div');

		// if (__DEBUG__) {
		// 	debug.style.position = 'absolute';
		// 	debug.style.top = elementTrigger + 'px';
		// 	debug.style.height = '20px';
		// 	debug.style.width = '100%';
		// 	debug.style.backgroundColor = 'tomato';
		// 	document.body.appendChild(debug);
		// }

		this.scrollHandler = function(event) {
			let spanFrom = 0;
			let spanTo = 0;

			if (
				(!this.props.lastSplitter(this.props.page) || !this.refs.splitter) ||
				(event && event.deltaY === 0)
			) {
				this.setState({
					...this.state,
					isActivePage: false,
				});

				return false;
			}

			const fixedEvent = event || { scrollY: window.scrollY };

			spanFrom = getOffsetTop(this.props.lastSplitter(this.props.page).getElement());
			spanTo = getOffsetTop(this.refs.splitter);

			const scrolledIntoSpan = (fixedEvent.scrollY >= spanFrom);
			const scrolledPastSpan = (fixedEvent.scrollY >= spanTo);

			// if (__DEBUG__) {
			// 	debug.style.top = spanTo + 'px'
			// 	//console.log(`%c ${this.props.page} :: (${fixedEvent.scrollY} >= ${spanFrom}) && !(${fixedEvent.scrollY} >= ${spanTo})`, (scrolledIntoSpan && !scrolledPastSpan) ? 'font-weight: bold; color: green;': 'font-weight: bold; color: red;');
			// }

			const isActivePage = (scrolledIntoSpan && !scrolledPastSpan);
			this.setState({
				...this.state,
				isActivePage,
			});

			if (isActivePage) {
				let url = `/awards/${window.location.search}`;

				if (this.props.hasPushState) {
					url = `/awards/page/${this.props.page}/${window.location.search}`;
				}

				this.replaceHistoryState(url);
			}

		}.bind(this);

		this.props.browser.scroll.register(this.scrollHandler);
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.scrollHandler);
	}

	render() {
		return (
			<li className='span6 page-splitter' data-page={this.props.page} ref='splitter' id={this.props.page}>
				{(this.state.isActivePage) && (
					<Helmet link={(() => this.getRelLinks())()} />
				)}
			</li>
		);
	}

	replaceHistoryState(path) {
		if (
			!!(window.history && window.history.replaceState) &&
			path !== window.location.pathname + window.location.search
		) {
			window.history.replaceState(window.history.state || {}, window.document.title, path);
		}
	}

	getRelLinks() {
		let relLinks = [];
		let pageNum = this.props.page;
		let hasPushState = this.props.hasPushState;

		if (hasPushState && this.state.isActivePage) {
			if (pageNum > 1) {
				relLinks.push({
					rel: 'prev',
					href: window.location.origin + '/awards/page/' + (pageNum - 1) + window.location.search,
				});
			}

			if (pageNum > 0) {
				relLinks.push({
					rel: 'next',
					href: window.location.origin + '/awards/page/' + (pageNum + 1) + window.location.search,
				});
			}

			relLinks.push({
				rel: 'canonical',
				href: window.location.origin + '/awards/page/' + pageNum + window.location.search,
			});

			// console.log(pageNum, relLinks);
		}

		return relLinks;
	}

	getElement() {
		return this.refs.splitter;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timeline/pageSplitter.js
 **/